import initialStepValidation from 'reducers/work-order/close-step-validation/initialStepValidation';
import { isSkinnyInstallType } from "../../../utils/helper";

export default (state, orderId) => {
  //for eventual future requirements
  const currentValidation = state.getIn(['workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation']) || initialStepValidation;

  const currentStatus = state.getIn([
    'workOrderDetails',
    orderId,
    "orderClose",
    "details",
    "closeOrderRequest",
    "orderStatus",
  ]);

  const serviceTypeId = state.getIn([
    'workOrderDetails',
    orderId,
    'schedulingSystemDetails',
    'details',
    'serviceOrderInfoV2',
    'serviceTypeId'
  ]);

  const submitAttempted = state.getIn([
    'workOrderDetails',
    orderId,
    'orderClose',
    'details',
    'deliveryProofDetails',
    'deliveryProofSubmitAttempted'
  ]);

  const deliveryProofBypassFlag = state.getIn([
    'workOrderDetails',
    orderId,
    'orderClose',
    'details',
    'closeOrderRequest',
    'deliveryProofAddMemoRequest',
    'deliveryProofBypassFlag'
  ]);

  if (!isSkinnyInstallType(serviceTypeId) || currentStatus === "NoAccess" || deliveryProofBypassFlag) {
    return currentValidation
      .setIn(['deliveryProof', 'isValid'], true);
  }

  if (!submitAttempted) {
    return currentValidation
      .setIn(['deliveryProof', 'isValid'], false);
  } else {
    return currentValidation
      .setIn(['deliveryProof', 'isValid'], true);
  }
};




// WEBPACK FOOTER //
// ./src/reducers/work-order/close-step-validation/deliveryProofValidator.js